import React from 'react'
import AdminForgotPassword from './AdminForgotPassword'

function SettingPassword() {
  return (
    <div>

        <AdminForgotPassword />
    </div>
  )
}

export default SettingPassword